module.exports = global["Components"] = require("-!/home/circleci/repo/frontend/node_modules/babel-loader/lib/index.js!/home/circleci/repo/frontend/node_modules/eslint-loader/index.js!./index.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?Components!./components/index.js
// module id = 126
// module chunks = 0